import React from "react";
import "./TestStyles.css";

const ThanksScreen = () => {

  return (
    <div className="ThanksStyle">
      <p>Thank you, that is the end of the exam.</p>
    </div>
  );
};

export default ThanksScreen;
